import { render } from "./ecuDetail.vue?vue&type=template&id=516ae727&scoped=true&ts=true"
import script from "./ecuDetail.vue?vue&type=script&lang=ts"
export * from "./ecuDetail.vue?vue&type=script&lang=ts"

import "./ecuDetail.vue?vue&type=style&index=0&id=516ae727&lang=less&scoped=true"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-516ae727"]])

export default __exports__